// Multi-city leg date math shared by the trip-creation/edit wizard
// (NewTripScreen's MultiCityStops), itinerary day-packing (screens/itinerary/
// logic.js), and booking-link date ranges (utils/bookingLinks.js).
//
// A leg is { destination, dayCount, overlapStart? }. dayCount is that leg's
// own inclusive span length in days. overlapStart marks that this leg's
// first day is the SAME calendar day as the previous leg's last day — a
// shared travel day (e.g. fly out of A in the morning, land in B that
// evening) instead of always starting the day after the previous leg ends.
export function addDaysIso(iso, days) {
  if (!iso) return '';
  const d = new Date(iso + 'T12:00:00');
  d.setDate(d.getDate() + days);
  return d.toISOString().split('T')[0];
}

export function daysBetweenIso(fromIso, toIso) {
  const a = new Date(fromIso + 'T12:00:00').getTime();
  const b = new Date(toIso + 'T12:00:00').getTime();
  return Math.round((b - a) / 86400000);
}

// offsets[i] = day-index (0-based, from trip dateStart) that leg i's own
// stay begins on. cardCounts[i] = how many itinerary day-cards belong to leg
// i — one less than dayCount when the NEXT leg overlaps leg i's last day
// (that shared day's card goes to the arriving leg instead, so no day-index
// is ever double-booked). totalDays is the flat day-card count for the trip.
export function computeLegSchedule(legs) {
  const list = legs || [];
  const offsets = [];
  let cursor = 0;
  list.forEach((leg, i) => {
    if (i > 0 && leg.overlapStart) cursor -= 1;
    offsets.push(cursor);
    cursor += leg.dayCount || 0;
  });
  const cardCounts = list.map((leg, i) => {
    const nextOffset = i < list.length - 1 ? offsets[i + 1] : offsets[i] + (leg.dayCount || 0);
    return Math.max(0, nextOffset - offsets[i]);
  });
  return { offsets, cardCounts, totalDays: cursor };
}
